import { render, staticRenderFns } from "./GoalsBalance.vue?vue&type=template&id=c7b877f2"
import script from "./GoalsBalance.vue?vue&type=script&lang=js"
export * from "./GoalsBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports